export default __webpack_public_path__ + "static/media/format_icon_checklist.db98b3c7.svg";